export const applyDataFormatOther = (allColumnsChart, questionCount) => { 
  let allColumnsAgrup = [] // donde guardar las columnas de referencia.
  let headers = ['Valores']
  for (let index = 0; index < allColumnsChart.length; index++) {
    const currentItemEntries = Object.entries(allColumnsChart[index]);
    const currentItemValues = Object.values(allColumnsChart[index]);
    // añadir los titulos.
    if(currentItemEntries[0][0] === 'INDICADOR'){
      headers = [ ...headers, `% ${currentItemEntries[0][1]}`, {role:'annotation'} ]
    }
    if(allColumnsAgrup.length < questionCount){
      // añadir los labels con cada valor
      // tengo que recorrer los valores de 'values' y solo cuando tenga la cantidad necesaria guardarlos
      let columnsAgrup = [] // donde guardare las agrupaciones.
      const iterableValues = currentItemValues.splice(1, currentItemValues.length); // elimino el indicador.
      for (let subIndex = 0; subIndex < iterableValues.length; subIndex++) {
        // verificar si ya esta la primera agrupacion.
        const subElement = iterableValues[subIndex]; 
        const valueSave = isNaN(parseInt(subElement)) ? [subElement] : [ subElement , `${parseInt( subElement )}%`];
        if(columnsAgrup.length <= 3){
          columnsAgrup = [ ...columnsAgrup, ...valueSave]
        }
        // guardo los datos y limpio el array para las siguientes busquedas.
        if(columnsAgrup.length === 3){
          allColumnsAgrup = [ ...allColumnsAgrup, columnsAgrup ]
          columnsAgrup = []
        }
      }
    }else{
      const iterableValues = currentItemValues.splice(1, currentItemValues.length)
        .filter(item => !isNaN(parseInt(item)) &&  item ); // elimino el indicador y obtengo los valores.
      let almacen = []
      for (let findIndex = 0; findIndex < allColumnsAgrup.length; findIndex++) {
        const element = allColumnsAgrup[findIndex];
        almacen = [ ...almacen, [
          ...element,
          iterableValues[findIndex], 
          `${parseInt(iterableValues[findIndex])}%`
        ]]
      }
      allColumnsAgrup = almacen;
      almacen = []
    }
  
  }
  
  return [ headers, allColumnsAgrup ]; 
}

export const applyDataFormatDefault = (
  allColumnsChart, titles, mathFilter='', addPercentage, replace = false, reference = {}, order = []
) => {
  const dataGraphicItems = allColumnsChart.map((item) => {
    let dataProcess = []; // almacenaje de datos
    const iterableItem = Object.entries(item); // genera un array a partir del OBJ
    for (const contentItem of iterableItem) {
      let dataValue = contentItem[1]; // contentItem[1] -> es el valor de la llave
      dataValue = isNaN(dataValue) ? dataValue : Math.round(dataValue);
      dataProcess = [...dataProcess, dataValue];
      if(typeof dataValue !== "string"){
        let value = addPercentage ? `${Math.round(dataValue)} %` : dataValue;
        dataProcess = [...dataProcess, value];
      }
    }
    return dataProcess; // retorno de array con datos preparados
  });

  let itemMath = []
  let listFilter = dataGraphicItems.filter(item => {
    if(item[0] === mathFilter){
      itemMath = item;
    }else{
      return item
    }
  });

  let allColumns = mathFilter === '' ? dataGraphicItems : [...listFilter, itemMath]

  // si order no es un array vacío, aplica el orden.
  if(order.length !== 0){
    let columnsOrdered = [];

    order.forEach(key => {
      const column = allColumns.find(column => column[0] === key);
      columnsOrdered.push(column);
    });

    allColumns = columnsOrdered;
  }

  if(replace){
    const onlyKeysObj = Object.keys(reference);
    onlyKeysObj.forEach(key => {
      allColumns.forEach((lista, j) => {
        let currentIndex = lista.findIndex(item => item === key);
        if(currentIndex !== -1){
          allColumns[j][currentIndex] = reference[key][0]
        }
      })
    });
  }

  return [titles, allColumns];
};

export const applyDataFormatTwo = (allColumnsChart, cleanHeader = false, sort = false, referencias) => { 
  let allColumns = [];
  let allColumnsCopy = []
  let headersColumns = ['valores']
  let headersColumnsRef = ['valores']
  // obtener titulos
  allColumnsChart.forEach(item => {
    const headerSaved = headersColumnsRef.find(header => header === item.LABEL);
    if( !headerSaved ) {
      headersColumns = [ ...headersColumns, `% ${item.LABEL}`, {role:'annotation'} ]
      headersColumnsRef = [ ...headersColumnsRef, item.LABEL ]
    }
  });

  for (let index = 0; index < allColumnsChart.length; index++) {
    if(allColumns.length === 0){
      let currentColumn = [];
      const iterableObj = Object.entries(allColumnsChart[index]);
      for (const currentItem of iterableObj) {
        const valueSave = isNaN(parseInt(currentItem[1])) ? currentItem[1] :  currentItem[1] ;
        currentColumn = [...currentColumn, [currentItem[0], Math.round(valueSave), `${Math.round(valueSave)}%`]];
      }
      allColumns = [...allColumns, ...currentColumn];
    }else{
      let columnsToReplace = []
      const iterableObj = Object.entries(allColumnsChart[index]);
      for (let subIndex = 0; subIndex < allColumns.length; subIndex++) {
        const element = allColumns[subIndex]; // ["INGRESOS_POS", 9.1, 9.1] 
        const valueAdd = iterableObj[subIndex][1];
        const valueSave = isNaN(parseInt(valueAdd)) ? valueAdd : valueAdd ;
        columnsToReplace = [ ...columnsToReplace, [ ...element, Math.round(valueSave), `${Math.round(valueSave)}%` ] ]
      }
      allColumns = columnsToReplace;
      allColumnsCopy = columnsToReplace;
    }
  }
  const columnsChart = allColumnsCopy.length === 0 ? allColumns : allColumnsCopy;
  const columnsSaved = columnsChart.filter(column => column[0] !== 'ORDEN' && column[0] !== 'LABEL') 
  const newColumnsWithHeaders = replaceHeadersWithReference([...columnsSaved], referencias);
  if(cleanHeader){
    const cleaned = newColumnsWithHeaders.splice(0, columnsChart.length);
    return [headersColumns, cleaned];
  }

  if(sort){
    const sorted = sortColumns([...newColumnsWithHeaders]);
    return [headersColumns, sorted];
  } 

  return [headersColumns, newColumnsWithHeaders];
}

export const applyDataFormatThree = (allColumnsChart = [], labels) => {
  let defineLabel = [] // donde guardo los labels 
  let headersColumn = labels.reduce( // donde guardo los headers
    (acc, current) => acc = [ ...acc, current, {role:'annotation'} ]
  , ['Valores']) 
  let columns = []
  allColumnsChart.forEach((item) => {
    // obtener la lista de labels sin repetir.
    const savedLabels = defineLabel.find(label => label === item.LABEL);
    if(!savedLabels){ // si el valor no esta guardado.
      defineLabel = [ ...defineLabel, item.LABEL ]
    }
  }); 

  // ahora que tengo los labels listos. buscar y obtener todos sus valores.
  defineLabel.forEach((label) => {
    const result = allColumnsChart.filter(itemColum => itemColum.LABEL === label);
    let allValue = []
    result.forEach(value => {
      allValue = [ ...allValue, 
        Object.values(value)[2], 
        `${parseInt(Object.values(value)[2])}%` 
      ]
    });

    // falta que los valores vangan ordenados por el string del label.
    columns = [ ...columns, [ label, ...allValue ] ]
  });

  // verificar que todas las columnas esten completas.
  const lengthRef = columns[0].length;
  const completeColumns = columns.map(column => {
    let currentColumn = column;
    if(currentColumn.length !== lengthRef){
      while(currentColumn.length !== lengthRef){
        currentColumn = [ ...currentColumn, 0, '0 %' ]
      }  
      return currentColumn;
    }

    return column;
  });

  return [headersColumn, completeColumns];
}

export const applyDataFormatFor = (dataChart = [], referencias) => {
  let headersColumns = ['valores']
  // obtener titulos
  dataChart.forEach(item => {
    const headerSaved = headersColumns.find(header => header === item.LABEL);
    if( !headerSaved ) headersColumns = [ ...headersColumns, `% ${item.LABEL}`, {role:'annotation'} ]
  });
  
  // completas las referencias con los datos correspondientes
  // console.log(referencias)
  const keysRef = Object.keys(referencias);
  keysRef.forEach(ref => {
    dataChart.forEach(item => {
      if(item[ref] || item[ref] === 0){
        const value = item[ref];
        referencias[ref] = [ ...referencias[ref], Math.round(value), `${Math.round(value)}%` ]
      }
    });
  });

  const valuesRef = Object.values(referencias);
  const contentColumns = valuesRef.map(list => list);
  // console.log("CONTENT COLUMN")
  // console.log(contentColumns)
  // const columnsSortedBY2021 = contentColumns.sort((a, b) => b[3] - a[3]);
  const columnsSortedBY2022 = contentColumns.sort((a, b) => b[5] - a[5]);
  return [headersColumns, columnsSortedBY2022];
  // const columnsSortedBY2023 = contentColumns.sort((a, b) => b[5] - a[5]);
  // return [headersColumns, columnsSortedBY2023];
}

export const applyDataFormatFor2 = (dataChart = [], referencias) => {
  let headersColumns = ['valores']
  // obtener titulos
  dataChart.forEach(item => {
    const headerSaved = headersColumns.find(header => header === item.LABEL);
    if( !headerSaved ) headersColumns = [ ...headersColumns, `% ${item.LABEL}`, {role:'annotation'} ]
  });
  
  // completas las referencias con los datos correspondientes
  // console.log(referencias)
  const keysRef = Object.keys(referencias);
  keysRef.forEach(ref => {
    dataChart.forEach(item => {
      if(item[ref] || item[ref] === 0){
        const value = item[ref];
        referencias[ref] = [ ...referencias[ref], Math.round(value), `${Math.round(value)}%` ]
      }
    });
  });

  const valuesRef = Object.values(referencias);
  const contentColumns = valuesRef.map(list => list);
  // console.log("CONTENT COLUMN")
  // console.log(contentColumns)
  // const columnsSortedBY2021 = contentColumns.sort((a, b) => b[3] - a[3]);
  // const columnsSortedBY2022 = contentColumns.sort((a, b) => b[5] - a[5]);
  return [headersColumns, contentColumns];
}

export const applyDataFormatFive = (dataChart = [], referencias, completeColumns = true) => {
  let headersColumns = ['valores']
  let headersColumnsRef = ['valores']
  // obtener titulos
  dataChart.forEach(item => {
    const headerSaved = headersColumnsRef.find(header => header === item.INDICADOR);
    if( !headerSaved ) {
      headersColumns = [ ...headersColumns, `% ${item.INDICADOR}`, {role:'annotation'} ]
      headersColumnsRef = [ ...headersColumnsRef, item.INDICADOR ]
    }
  });
  
  // completas las referencias con los datos correspondientes
  const keysRef = Object.keys(referencias);
  keysRef.forEach(ref => {
    dataChart.forEach(item => {
      const valuesObj = Object.values(item); 
      const length = valuesObj.length;
      const [ key ] = valuesObj;
      const value = valuesObj[length - 1];
      if(key === ref){
        referencias[ref] = [ ...referencias[ref], Math.round(value), `${Math.round(value)}%` ]
      }
    });
  });

  const valuesRef = Object.values(referencias);
  const contentColumns = valuesRef.map(list => list);

  if(completeColumns){
    // verificar que todas las columnas esten completas.
    const lengthRef = contentColumns[0].length;
    const completeColumns = contentColumns.map(column => {
      let currentColumn = column;
      if(currentColumn.length !== lengthRef){
        while(currentColumn.length !== lengthRef){
          currentColumn = [ ...currentColumn, 0, '0 %' ]
        }  
        return currentColumn;
      }

      return column;
    });
    return [headersColumns, completeColumns];
  }

  return [headersColumns, contentColumns]
}

const sortColumns = (arr) => {
  const length = arr.length; 
  const spliced = [...arr].splice(0, length);
  return spliced.sort((a, b) => b[3] - a[3]);
}

const replaceHeadersWithReference = ( arr = [], referencias ) => {
  const listado = [];
  arr.forEach(item => {
    const indicador = item[0];
    const elementIndicador = referencias[indicador];
    if(elementIndicador){
      const valuesIndicador = item.splice(1, item.length);
      listado.push([ ...elementIndicador, ...valuesIndicador ]);
    }
  });
  return listado;
}